
class DocumentDetailHeaderView extends MUIView
{ 
    protected documentNumberLabel:MUILabel = null;
    protected referenceLabel:MUILabel = null;
    protected referenceTextField:MUITextField = null;
    protected dateButton:MUIButton = null;
    protected dateTextField:MUITextField = null;
    protected dateLabel:MUILabel = null;

    protected processButton:MUIButton = null;

    awakeFromHTML(){     
        this.documentNumberLabel = MUIOutlet(this, "document-number-lbl", "MUILabel");
        
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");
        this.referenceTextField = MUIOutlet(this, "reference-tf", "MUITextField");
        this.setupReferenceTextField(this.referenceTextField);
        
        this.dateButton = MUIOutlet(this, "date-btn", "MUIButton");
        this.setupCalendarButton(this.dateButton);

        this.dateTextField = MUIOutlet(this, "date-tf", "MUITextField");
        this.setupDocumentDateTextField(this.dateTextField);
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        
        this.processButton = MUIOutlet(this, "process-btn", "MUIButton");
        if (this.processButton != null) this.processButton.setAction(this, this.showProcessAlert);
    }

    protected _document:DBDocument = null;
    setDocument(item:DBDocument) {
        this._document = item;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        
        if (this.documentNumberLabel) this.documentNumberLabel.text = item.documentNumber;        
        if (item instanceof PurchaseInvoice) {
            if (this.referenceLabel) this.referenceLabel.text = item.externalReference;
            if (this.referenceTextField) this.referenceTextField.text = item.externalReference;
        }

        let date_str = ad.dateTimeFormatter.stringFromDate( item.date );
        if (this.dateLabel) this.dateLabel.text = date_str;
        if (this.dateTextField) this.dateTextField.text = date_str;
    }

    protected setupReferenceTextField( textField:MUITextField ){
        if (textField == null) return;

        textField.setOnChangeText(this, function(this:DocumentDetailHeaderView, control:MUITextField, value:string){            
            (this._document as PurchaseInvoice).externalReference = value;
        });
    }


    protected setupDocumentDateTextField(textField:MUITextField){
        if (textField == null) return;

        textField.setOnChangeText(this, function(this:DocumentDetailHeaderView, control:MUITextField, value:string){
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            this._document.date = ad.dateTimeFormatter.dateFromString(value);    
        });
    }

    protected setupCalendarButton(button:MUIButton){
        if (button == null) return;

        button.setAction(this, function(){

            let dp = new MUIDatePickerController();
            dp.init();        
            dp.delegate = this;        
            dp.modalPresentationStyle = MUIModalPresentationStyle.Popover;
            // dp.tag = type;

            let pc = dp.popoverPresentationController;
            pc.sourceRect = button.frame;
            pc.sourceView = button;

            AppHelper.sharedInstance().presentViewController(dp, true);
        });
    }

    didSelectDate(datePickerController:MUIDatePickerController, date:Date) {
        // let source = datePickerController.popoverPresentationController.sourceView;
        let newDate = this.newDateFromValue(this._document.date, date);
        this._document.date = newDate;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.dateTextField.text = ad.dateTimeFormatter.stringFromDate( newDate );
        // this.dateDidChange(datePickerController.tag, newDate);
    }

    private newDateFromValue(oldDate:Date, newDate:Date):Date {
        if (oldDate == null) {
            let now = MIODateNow();            
            newDate.setHours(now.getHours());
            newDate.setMinutes(now.getMinutes());
            newDate.setSeconds(now.getSeconds());
            return newDate;
        }
        else {
            newDate.setHours(oldDate.getHours());
            newDate.setMinutes(oldDate.getMinutes());
            newDate.setSeconds(oldDate.getSeconds());
            return newDate;
        }
    }

    protected dateDidChange(type:NoteDetailHeaderViewDateType, date:Date){

    }

    protected showProcessAlert(){
        if (this._document.status != DBDocumentStatus.processed) {
            this.showProcessOptions();
        } 
        else 
        {
            let avc = new MUIAlertViewController();
            avc.initWithTitle(MIOLocalizeString("WARNING", "WARNING"), MIOLocalizeString("ARE_YOU_SURE_YOU_WANT_TO_UNPROCESS_THIS_DOCUMENT?", "ARE YOU SURE YOU WANT TO UNPROCESS THIS DOCUMENT?"), MUIAlertViewStyle.Default);
            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("UNPROCESS", "UNPROCESS"), MUIAlertActionStyle.Destructive, this, function(){
                this._document.status = DBDocumentStatus.unprocessed;
                DBHelper.saveMainContext();
            }));

            avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));
            AppHelper.sharedInstance().presentViewController(avc, true);
        }
    }

    protected showProcessOptions(){ }


    protected processDocument(context:any) {
        this._document.status = DBDocumentStatus.processed;
        DBHelper.saveMainContext();
    }
}